<template>
	<sf-layout :sideMenu="openedSideMenu" :contentClick="hideOtherView">
		<!-- 상단 메뉴를 포함한 상단 헤더 영역 -->
		<template v-slot:header>
			<header-layout
				:userName="user.userName"
				:menu="topMenuData"
				:menuType="menuData.scrType"
				:useSitemap="menuData.sitemapYN === 'Y'"
				@toggleSideMenu="toggleSideMenu"
				@toggleUserSide="toggleUserSide"
				@clickedMenu="onClickTopMenu"
				@sitemapClick="openSitemap"
				@openScreen="openScreen"
			/>
		</template>

		<!-- 사이드 메뉴를 사용할 경우 -->
		<template v-if="menuData.useSideMenuYN === 'Y'" v-slot:leftSide>
			<!-- 사이드 메뉴 -->
			<sf-side-menu
				:show="openedSideMenu"
				:menu="sideMenuData"
				useCloseBtn
				:copyright="copyright"
				:spread="sideMenuSpread"
				@menuClick="openScreen"
				@closeSideMenu="toggleSideMenu"
			/>
		</template>

		<!-- 사용자 설정 우측 사이드바 -->
		<template v-slot:rightSide>
			<user-sidebar v-show="openedUserSide" @toggleUserSide="toggleUserSide" />
		</template>

		<template v-slot:mainContent>
			<!-- onsite 일때 Home 화면을 위젯으로 보여줌 -->
			<!-- <widget v-if="menuData.scrName === 'Home'" /> -->
			<component v-if="isOnsite && menuData.scrName === 'Home'" :is="widgetComponent"></component>
			<!-- *  Home 화면 content를 iframe으로 위젯 화면 보여줌 -->
			<sf-iframe
				v-else-if="!isOnsite && menuData.scrName === 'Home'"
				:url="homeContentUrl"
				:screenParam="{ scrId: homeScrId }"
				:iframeParam="userInfo"
			/>

			<!-- Tab 메뉴 형태일 경우 -->
			<sf-menu-tab
				v-else-if="menuData.useTabMenuYN === 'Y'"
				ref="menuTab"
				:maxTab="30"
				:contentType="isOnsite ? 'components' : 'iframe'"
				:tabParam="userInfo"
				:removeAllLabel="getMessage_('SWCC000562')"
				:exceeded="exceeded"
				@emptiedTab="openContentScreen"
			/>

			<!-- Tab 메뉴가 아닌 Route 형태일 경우 -->
			<router-view v-else></router-view>
		</template>
	</sf-layout>
</template>

<script>
//메뉴 화면의 Layout
import { rootComputed, rootMethods } from '@/store/common/helpers';
import HeaderLayout from './Header/HeaderLayout.vue';
import UserSidebar from './UserSidebar/UserSidebar';
import Sitemap from '@/views/Pages/Sitemap/Sitemap';
// import Widget from '@common/Widget/Widget.vue';

export default {
	components: {
		HeaderLayout,
		UserSidebar
		// Widget
	},

	data() {
		return {
			menuData: {}, //화면의 메뉴 정보
			topMenuData: [], //상단 메뉴에 보여줄 메뉴 정보(+좌측 메뉴와 함께 사용할 경우 하위 메뉴 정보도 포함)
			sideMenuData: {}, //좌측 메뉴에 보여줄 메뉴 정보
			openedSideMenu: false, //좌측 메뉴 열림 닫힘 여부 (초기값: 닫힌 상태)
			openedUserSide: false, //사용자 설정 사이드바 열림 닫힘 여부 (초기값: 닫힌 상태)
			widgetComponent: null //onsite용 Home 화면에서 사용할 위젯 화면
		};
	},

	//로그인 페이지 이후 처음 MenuLayout이 mounted 될 때
	mounted() {
		window.addEventListener('resize', this.handleResize); //resize에 대한 이벤트 리스너(화면 사이즈 변경 감지) 등록
		window.addEventListener('message', this.checkMessage); //message에 대한 이벤트 리스너(화면 이동 요청 감지, 도메인에서 User 관련 변수 요청 감지) 등록

		//초기에 route의 name 정보를 이용해 Vuex Store에 저장된 메뉴 정보들에서 name으로 메뉴 정보 Get
		//route name이 testScreen(tab이 아닌 routing 형식), test(tab  메뉴 형식) 둘 중 어떤 형태로 와도 Store에서 test로 메뉴 검색
		//검색한 메뉴를 MenuLayout에서 사용할 수 있도록 menuData에 넣는다.
		this.menuData = this.getMenu_({ name: this.$route.name.split('Screen')[0] });

		//상단메뉴를 사용할 경우
		if (this.menuData.useTopMenuYN === 'Y') {
			this.topMenuData = this.menuData.menuItemList; //상단 메뉴: 사용자 메뉴 정보
			this.sideMenuData = this.menuData.menuItemList[0]; //좌측 메뉴: 사용자 메뉴의 첫번째 댑스 정보
		}
		//상단 메뉴를 사용하지 않고 좌측 메뉴만 사용할 경우
		else {
			this.sideMenuData = { items: this.menuData.menuItemList }; //좌측 메뉴: 사용자 메뉴 정보
		}

		if (this.menuData.scrName === 'Home') {
			this.widgetComponent = () => import(`@/views/cc/Widget/Widget.vue`);
		}
		//contentScrId 값이 있을 경우 메뉴의 첫 화면 Display
		this.openContentScreen();
	},

	//MenuLayout이 beforeDestroy 될 때
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize); //resize에 대한 이벤트 리스너(화면 사이즈 변경 감지) 삭제
		window.removeEventListener('message', this.checkMessage); //message에 대한 이벤트 리스너(화면 이동 요청 감지) 삭제
	},

	computed: {
		...rootComputed,

		// 화면 iframe에게 전달할 쿼리 스트링 정보: 사용자 정보
		userInfo() {
			return {
				topSkin: this.topSkin, //색상 테마
				font: this.font, //폰트 테마
				plantCd: this.user.plantCd, //공장 코드
				langCd: this.langCd //언어
			};
		},

		//환경변수: onsite Project 여부(Boolean) / true: Onsite, 그 외: MSA
		isOnsite() {
			return process.env.VUE_APP_ONSITE_PROJECT === 'true';
		},

		//환경변수: 좌측 메뉴 spread 여부(Boolean) / true: spread, 그 외: 하나의 메뉴만 펼침
		sideMenuSpread() {
			return process.env.VUE_APP_SIDE_MENU_SPREAD === 'true';
		},

		//환경변수: 좌측 메뉴 고정 여부(Boolean) / true: 좌측 메뉴 고정, 그 외: 좌측 메뉴 영역 밖 클릭시 좌측 메뉴 닫힘
		sideMenuFixed() {
			return process.env.VUE_APP_SIDE_MENU_FIXED === 'true';
		},

		//환경변수: 카피라이트 내용(String)
		copyright() {
			return process.env.VUE_APP_COPYRIGHT;
		},

		icpNo() {
			return process.env.VUE_APP_ICP_NO;
		},
	},

	watch: {
		//화면의 url 정보가 바뀌었을 때
		$route(val, oldVal) {
			const { name, params, path } = this.$route;

			//route의 name이 바뀔 경우(=Layout이 변경될 경우) 좌측메뉴 닫기
			if (oldVal.name !== name) {
				this.hideOtherView();
			}

			//변경된 route의 name 정보를 이용해 Vuex Store에 저장된 메뉴 정보들에서 name으로 메뉴 정보 Get
			//route name이 testScreen(tab이 아닌 routing 형식), test(tab  메뉴 형식) 둘 중 어떤 형태로 와도 Store에서 test로 메뉴 검색
			//검색한 메뉴를 MenuLayout에서 사용할 수 있도록 menuData에 넣는다.
			this.menuData = this.getMenu_({ name: name.split('Screen')[0] }); //menuData에 메뉴 정보 Set

			//상단메뉴를 사용할 경우
			if (this.menuData.useTopMenuYN === 'Y') {
				this.topMenuData = this.menuData.menuItemList; //상단 메뉴: 사용자 메뉴 정보
				this.sideMenuData = this.menuData.menuItemList[0]; //좌측 메뉴: 사용자 메뉴의 첫번째 댑스 정보
			}
			//상단 메뉴를 사용하지 않고 좌측 메뉴만 사용할 경우
			else {
				this.sideMenuData = { items: this.menuData.menuItemList }; //좌측 메뉴: 사용자 메뉴 정보
			}

			//params가 있다면 (params: 보여줄 화면에 대한 정보)
			if (!this.$sf_isEmptyObj(params)) {
				const { scrId, queryString } = params; //scrId: 보여줄 화면 Id, queryString: 화면(iframe)에 넘겨줄 queryString

				//탭 형식이라면
				if (this.menuData.useTabMenuYN === 'Y') {
					this.$sf_removeTab(scrId); //같은 화면이 열려있다면 닫기
				}

				//Vuex의 메뉴 Map에서 scrId를 이용해 화면 정보 검색
				const item = this.menuData.menuItemMap.get(scrId);

				// item이 있을 경우에만
				if (item) {
					this.openScreen({ item, queryString: queryString }); //화면을 열기 위한 함수 호출
				}

				return; //params가 정보를 가지고 화면을 열어준 후 탈출
			}

			//contentScrId 값이 있을 경우 메뉴의 첫 화면 Display
			this.openContentScreen();
		},

		//store의 다국어 Map이 변경이 감지되면 헤더에 넣어주는 menuData의 menuItemList 변경(다국어 적용을 위함)
		userMessage() {
			const menuItemList = this.calculateMenu(this.menuData.menuItemList); //메뉴 정보 계산
			this.menuData = { ...this.menuData, menuItemList }; //menuData 변경

			//상단메뉴를 사용할 경우
			if (this.menuData.useTopMenuYN === 'Y') {
				this.topMenuData = this.menuData.menuItemList; //상단 메뉴: 사용자 메뉴 정보
				this.sideMenuData = this.menuData.menuItemList[0]; //좌측 메뉴: 사용자 메뉴의 첫번째 댑스 정보
			}
			//상단 메뉴를 사용하지 않고 좌측 메뉴만 사용할 경우
			else {
				this.sideMenuData = { items: this.menuData.menuItemList }; //좌측 메뉴: 사용자 메뉴 정보
			}

			//메뉴가 탭 형식일 경우, 메뉴 탭 다국어 처리 변경
			if (this.menuData.useTabMenuYN === 'Y') {
				const tabs = this.$refs.menuTab.$sf_getTabs().map(tab => {
					return { ...tab, name: this.getMessage_(tab.msgKey) };
				}); //탭 정보 가공

				this.$refs.menuTab.$sf_setTabs(tabs); //메뉴 탭 menu 정보 set
			}
		}
	},

	methods: {
		...rootMethods,

		//contentScrId 값이 있을 경우 메뉴의 첫 화면 Display
		openContentScreen() {
			if (this.menuData.contentScrId) {
				this.$nextTick(function () {
					if (this.menuData.scrUrl === this.$route.path) {
						//현재 url과 메뉴의 url이 같을 때
						const useTabMenuYN = this.menuData.useTabMenuYN; //탭 형식 사용 여부
						const item = this.menuData.menuItemMap.get(this.menuData.contentScrId); // 첫화면 화면 정보

						//탭이 아니거나, 탭인데 열린 탭이 없는 경우만 첫 화면 Display
						if (useTabMenuYN === 'N' || (useTabMenuYN === 'Y' && this.$refs.menuTab.$sf_getTabs().length === 0)) {
							//첫 화면이 sitemap일 경우
							if (this.menuData.contentScrId === 'sitemap') {
								this.openSitemap(); //sitemap Display
							} else {
								this.openScreen({ item }); //화면을 열기위한 함수 호출
							}
						}
					}
				});
			}
		},

		checkMessage(e) {
			//화면 이동 이벤트 수행 함수
			if (e.data.message === 'moveScreen') {
				//message가 moveScreen 맞으면
				const { scrType, scrId, queryString } = e.data; //화면으로부터 받은 이동할 화면(targetMenu) data
				const targetMenuData = this.getMenu_({ type: scrType }); //targetMenu 정보 추출
				const item = targetMenuData.menuItemMap.get(scrId); //targetMenu 메뉴에서 targetScreen 추출

				//현재 메뉴와 targetMenu와 동일하다면
				if (scrType === this.menuData.scrType) {
					this.openScreen({ item, queryString }); //바로 화면 호출
				}

				//현재 메뉴와 targetMenu와 다르다면
				else {
					//메뉴 이동하면서 params로 targetScreen 정보 전달
					this.$router.push({ name: targetMenuData.scrName, params: { scrId, queryString } }).catch(() => {});
				}
			} else if (e.data.message === 'checkAuthorities') {
				e.source.postMessage({ message: 'getAuthorities', contents: this.getVuexVariable_(e.data.key) }, '*');
			}
		},

		//resize 이벤트 감지시
		handleResize() {
			//브라우저 창크기가 1281 이하가 되면
			if (window.innerWidth <= 1281) {
				this.hideOtherView(); //열려있는 사이드 바를 닫음
			}
		},

		//컨텐츠 영역 클릭시 열려있는 좌측 메뉴/사이드 바를 닫는 함수
		hideOtherView() {
			if (!this.sideMenuFixed) {
				this.openedSideMenu = false; //좌측 메뉴 닫음
			}

			this.openedUserSide = false; //사용자 설정 사이드 바 닫음
		},

		//좌측 메뉴 toggle 기능
		toggleSideMenu() {
			this.openedSideMenu = !this.openedSideMenu; //좌측 메뉴 열림/닫힘 toggle
		},

		//사용자 설정 사이드바 toggle 기능
		toggleUserSide() {
			this.openedUserSide = !this.openedUserSide; //사용자 설정 사이드바 열림/닫힘 toggle
		},

		//상단 메뉴 클릭시
		onClickTopMenu({ item }) {
			//하위 메뉴가 없으면
			if (!item.items || item.items.length === 0) {
				this.openScreen({ item }); //화면을 열기위한 함수 호출
			} else {
				this.openedSideMenu = true; //좌측 메뉴 열기
				this.sideMenuData = item; //좌측 메뉴에 하위 메뉴 정보 전달
			}
		},

		//화면 호출 함수
		async openScreen({ item, queryString }) {
			//onsite일 때 화면 정보 조회
			if (this.isOnsite && item.scrId != 'sitemap' && item.scrId) {
				await this.getScreen_({ scrId: item.scrId })
					.then(header => {
						if (header.code !== 0) {
							this.$sf_toast({
								...this.$sf_setToastOption(header),
								message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
							});
						}
					})
					.catch(error => {
						this.$sf_toast({ title: 'Error', type: 'error', message: error.message });
					});
			}

			// Home 화면에 대한 처리
			if (this.menuData.scrType === 'H') {
				this.$router.push(item.url).catch(() => {}); //클릭한 메뉴를 라우팅하기 위한 URL로 이동
			}

			// 탭 메뉴 형식일 경우
			else if (this.menuData.useTabMenuYN === 'Y') {
				const postParam = item.direct ? { message: 'sendUser', ...this.getUser_ } : null; //direct 이동 화면이라면 post로 보낼 데이터 셋팅
				this.$sf_addTab(item, item.scrId, { scrId: item.scrId, ...queryString }, postParam); //화면 탭 추가
			}
			//탭 형식이 아닌 route 방식일 경우
			else {
				this.$router.push(`${this.menuData.scrUrl}/${item.scrId}`).catch(() => {}); //클릭한 메뉴를 라우팅하기 위한 URL로 이동
			}
		},

		//사이트 호출 함수
		openSitemap() {
			if (this.menuData.useTabMenuYN === 'Y') {
				this.openScreen({
					item: {
						name: this.getMessage_('SWCC000438'), //탭에 표시하기 위한 이름, 다국어: 사이트맵
						component: Sitemap,
						scrId: 'sitemap',
						msgKey: 'SWCC000438'
					}
				}); //메뉴 클릭 메서드에 화면 정보 전달
			} else {
				this.$router.push(`${this.menuData.scrUrl}/sitemap`).catch(() => {}); //클릭한 메뉴를 라우팅하기 위한 URL로 이동
			}
		},

		//탭 개수 초과시 호출되는 함수
		exceeded() {
			this.$sf_showMessage({
				title: this.getMessage_('SWCC000761'), // 다국어: 탭 개수 초과
				icon: 'error',
				message: this.getMessage_('SWCC000762') //다국어: 열려있는 탭을 닫고 새로 열어주세요.
			});
		},

		//메뉴 리스트를 가공하기 위한 재귀 함수
		calculateMenu(menus) {
			return menus.map(menu => {
				let temp = { ...menu };
				temp.name = this.getMessage_(menu.msgKey); //다국어를 적용한 메뉴 명으로 등록
				if (temp.items) {
					temp.items = this.calculateMenu(temp.items);
				}
				return temp;
			});
		}
	}
};
</script>

<style></style>
